import { defineAsyncComponent } from "vue";
import i18n from "../i18n";
import { Button, Modal } from "ant-design-vue";
import lodash from "lodash";
import { openModalCancelForm } from "../components/form/cancel-form.logic";

export const CIcon = defineAsyncComponent(() => import("../components/icon/CIcon"));

export const createButton = ({ isLabel = true, text, classStyle, size = "small", onClick, icon, confirm, disabled }) => {
    let label = null;
    let handleOnClick = onClick;
    if (isLabel) {
        label = <span>{text}</span>;
    }
    if (confirm && (!confirm.canHandle || confirm.canHandle?.())) {
        handleOnClick = () => {
            Modal.confirm({
                title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text }),
                autoFocusButton: "cancel",
                ...confirm,
                onOk: onClick,
            });
        };
    }
    return (
        <Button class={classStyle} size={size} onClick={handleOnClick} disabled={disabled}>
            {icon}
            {label}
        </Button>
    );
};

export const createButtonCreate = ({ onClick, isLabel = true, classStyle = "", options }) => {
    return createButton(
        lodash.merge(
            {
                isLabel,
                text: i18n.global.t("button.createNew"),
                classStyle: "c-btn-create btn-success " + classStyle,
                onClick,
                icon: <CIcon file="plus.svg"></CIcon>,
            },
            options
        )
    );
};

export const createButtonView = ({ onClick, isLabel = true, classStyle = "", options }) => {
    return createButton(
        lodash.merge(
            {
                isLabel,
                text: i18n.global.t("button.view"),
                classStyle: "c-btn-view btn-info " + classStyle,
                onClick,
                icon: <CIcon file="eye.svg"></CIcon>,
            },
            options
        )
    );
};

export const createButtonEdit = ({ onClick, isLabel = true, classStyle = "", options }) => {
    return createButton(
        lodash.merge(
            {
                isLabel,
                text: i18n.global.t("button.edit"),
                classStyle: "c-btn-edit btn-warning " + classStyle,
                onClick,
                icon: <CIcon file="edit.svg"></CIcon>,
            },
            options
        )
    );
};

export const createButtonActive = ({ onClick, isLabel = true, classStyle = "", options }) => {
    return createButton(
        lodash.merge(
            {
                isLabel,
                text: i18n.global.t("button.active"),
                classStyle: "c-btn-active btn-primary " + classStyle,
                onClick,
                icon: <CIcon file="active.svg"></CIcon>,
            },
            options
        )
    );
};

export const createButtonArchive = ({ onClick, isLabel = true, classStyle = "", options }) => {
    return createButton(
        lodash.merge(
            {
                isLabel,
                text: i18n.global.t("button.archive"),
                classStyle: "c-btn-archive btn-danger " + classStyle,
                onClick,
                icon: <CIcon file="archive.svg"></CIcon>,
            },
            options
        )
    );
};

export const createButtonDelete = ({ onClick, isLabel = true, classStyle = "", options }) => {
    return createButton(
        lodash.merge(
            {
                isLabel,
                text: i18n.global.t("button.delete"),
                classStyle: "c-btn-delete btn-danger m-1" + classStyle,
                onClick,
                icon: <CIcon file="delete.svg"></CIcon>,
            },
            options
        )
    );
};

export const createButtonCancel = ({ props, onClick, isLabel = true, classStyle = "", options }) => {
    return createButton(
        lodash.merge(
            {
                isLabel,
                text: i18n.global.t("button.cancel"),
                classStyle: "c-btn-delete btn-danger " + classStyle,
                onClick: () => {
                    openModalCancelForm({
                        props,
                        onClick,
                        title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: options.modalTitle }),
                    });
                },
                icon: <CIcon file="archive.svg"></CIcon>,
            },
            options
        )
    );
};

export const createButtonSave = ({ onClick, isLabel = true, classStyle = "", options }) => {
    return createButton(
        lodash.merge(
            {
                isLabel,
                text: i18n.global.t("button.save"),
                classStyle: "c-btn-save btn-primary " + classStyle,
                onClick,
                icon: <CIcon file="save.svg"></CIcon>,
            },
            options
        )
    );
};
